export const documentSettingsFormTestIds = {
  companySelect: 'company-select',
  contactSelect: 'contact-select',
};
